import { create } from 'zustand'

interface LocationState {
	isLocationActive: boolean
	lat: number | null
	long: number | null
	isLocationLoading: boolean
	setLocationActive: (isActive: boolean) => void
	setCoordinates: (lat: number | null, long: number | null) => void
	setLocationLoading: (isLoading: boolean) => void
}

const useLocationStore = create<LocationState>(set => ({
	isLocationActive: localStorage.getItem('location') !== null,
	lat: null,
	long: null,
	isLocationLoading: false,

	setLocationActive: (isActive: boolean) => {
		if (isActive) {
			localStorage.setItem('location', 'true')
		} else {
			localStorage.removeItem('location')
		}
		set({ isLocationActive: isActive })
	},

	setCoordinates: (lat: number | null, long: number | null) => {
		set({ lat, long })
	},

	setLocationLoading: (isLoading: boolean) => {
		set({ isLocationLoading: isLoading })
	},
}))

export default useLocationStore